import React, { useEffect, useState } from 'react'
import * as Yup from 'yup';
import { Modal, Tooltip } from 'antd'
import { Visibility } from '@app/components'
import { Button, FormatText, FormSelect, FormSubmitButton, FormTextArea, MasterDetailForm, Row, Widget } from '@digital/ui'
import { getAllStatusSasPropostaOptions } from '@app/api/status';
import { alterarStatusProposta, getDadosProposta } from '@app/api/sas/sasProposta';
import { reloadVendorListState } from '../atoms';
import { useRecoilState } from 'recoil';

interface Props {
    sasPropostaId: string
}

const ModalEditarVendorStatus = (props: Props) => {
    const { sasPropostaId } = props

    const [reloadVendorList, setReloadVendorList] = useRecoilState(reloadVendorListState);

    const [exibirModal, setExibirModal] = useState(false)
    const [initialValues, setInitialValues] = useState({});


    useEffect(() => {
        if (exibirModal && sasPropostaId) {
            getDadosProposta(sasPropostaId).then(data => {
                if (data) {
                    setInitialValues(data)
                }
            })
        }
    }, [exibirModal, sasPropostaId])

    const onSubmit = (values: any) => {
        alterarStatusProposta(
            sasPropostaId,
            values.statusSasPropostaId,
            values.justificativa
        ).then((data: any) => {
            if (data && data.valid) {
                setReloadVendorList(!reloadVendorList);
                setExibirModal(false)
            }
        })
    }

    return (
        <>
            <Tooltip title="Editar" >
                <Button key="vendorListEdit" icon="editing-pencil" onClick={() => setExibirModal(true)} />
            </Tooltip>
            <Visibility visible={exibirModal}>
                <Modal
                    title="Editar Vendor List Status"
                    width="510px"
                    visible={exibirModal}
                    onCancel={() => setExibirModal(false)}
                    footer={null}
                >
                    <MasterDetailForm
                        key="formEditVendorStatus"
                        initialValues={initialValues}
                        onSubmit={onSubmit}
                        validationSchema={Yup.object().shape({
                            justificativa: Yup.string().required('O campo deve ser informado'),
                        })}
                        actions={[
                            <Button
                                type="link"
                                onClick={() => {
                                    setExibirModal(false);
                                }}
                                key="close">
                                Fechar
                            </Button>,
                            <FormSubmitButton noIcon type="primary">
                                <FormatText id="ui.commons.save" uppercase />
                            </FormSubmitButton>,
                        ]}
                    >
                        <Widget>
                            <Row>
                                <FormSelect
                                    label="Status desta Cotação"
                                    getOptions={getAllStatusSasPropostaOptions}
                                    name="statusSasPropostaId"
                                    span={4}
                                />
                            </Row>
                            <Row>
                                <FormTextArea
                                    label="Justificativa"
                                    name="justificativa"
                                    span={12}
                                    rows={4}
                                />
                            </Row>
                        </Widget>
                    </MasterDetailForm>
                </Modal>
            </Visibility>
        </>
    )
}

export default ModalEditarVendorStatus